// ============================================================================
// pwa-links-client-mod -- Mod Definition
//
// 提供：
// 1. 公开导航页面 — /pwa-links（PWA 应用卡片列表）
// 2. Admin Slot — "PWA 管理"区块（管理 PWA 链接）
// ============================================================================
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG } from '@hvsin/ui-registry-contracts';
import { ADMIN_SLOTS_INTERFACE_TAG } from '@hvsin/admin-contracts';
import { FETCH_SERVICE_INTERFACE_TAG } from '@hvsin/fetch-contracts';
import { CLIENT_SERVICE_REGISTRY_INTERFACE_TAG } from '@hvsin/ui-registry-contracts';
import { PwaLinksClientRegistrar } from './pwa-links-client-registrar.js';
import { PwaLinksApiClient } from './pwa-links-api-client.js';
export const pwaLinksApiClientServiceDef = {
    serviceTag: 'pwaLinksApiClient',
    serviceImpl: PwaLinksApiClient,
    dependencies: [FETCH_SERVICE_INTERFACE_TAG],
};
export const pwaLinksClientRegistrarServiceDef = {
    serviceTag: 'pwaLinksClientRegistrar',
    serviceImpl: PwaLinksClientRegistrar,
    dependencies: [
        PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
        ADMIN_SLOTS_INTERFACE_TAG,
        CLIENT_SERVICE_REGISTRY_INTERFACE_TAG,
        'pwaLinksApiClient',
    ],
};
export const pwaLinksClientMod = {
    name: 'pwa-links-client',
    modDependencies: ['ui-registry', 'admin-center-client'],
    serviceDefs: [
        pwaLinksApiClientServiceDef,
        pwaLinksClientRegistrarServiceDef,
    ],
};
//# sourceMappingURL=mod.js.map